<template>
    <div id="Intake" class="dashboard-card d-flex">
        <CardTemplate>
            <!-- HEADER -->
            <template #header>
                <section class="card-title">
                    <span>Intake (Past 30 Days)</span>
                </section>
            </template>
            <!-- CONTENT -->
            <!-- LOADING -->
            <template #content>
                <div class="loading-state" v-if="isLoading && !hasError">
                    <i class="fas fa-spinner fa-pulse fa-fw"></i>
                    <b>Loading your intake count</b>
                    <i class="fas fa-spinner fa-pulse fa-fw"></i>
                </div>
                <!-- ERROR -->
                <div class="mt-5 text-center" v-if="hasError && !isLoading">
                    <p>
                        There was a problem while fetching your intake count.
                        <br />
                        Please try again.
                    </p>
                    <button class="btn btn-primary" @click="getIntakeCount()">Try Again</button>
                </div>
                <!-- NO DATA -->
                <section v-if="intakeCount.length === 0 && !isLoading && !hasError" class="no-data">
                    <i class="mb-3"> Good Job! There were no intake count. </i>
                </section>
                <!-- DATA -->
                <div class="h-100 overflow-auto position-relative" v-if="intakeCount.length > 0">
                    <table id="dashboard-table">
                        <tr>
                            <th>Service</th>
                            <th>Inquiry</th>
                            <th>Referral</th>
                        </tr>
                        <tr v-for="intake in intakeCount" :key="intake.id">
                            <td>{{ ApplicationNamesEnum.getDescriptionUsingValue(intake.application) }}</td>
                            <td>{{ intake.inquiryCount }}</td>
                            <td>{{ intake.referralCount }}</td>
                        </tr>
                    </table>
                    <div class="w-100 last-div table-background position-absolute"></div>
                </div>
            </template>
        </CardTemplate>
    </div>
</template>

<script lang="ts" src="./Intake.ts"></script>
